import { login, logout, getInfo, getModules, getModulesTree, getOrgs } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { local } from '@/utils'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    modules: null,
    defaultorg: null,// 登录后默认的操作机构
    orgid: '',
    deptid: '',
    detpinfo: {},
    sessionInfo: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_MODULES: (state, modules) => {
      state.modules = modules
    },
    SET_DEFAULTORG: (state, org) => {
      state.defaultorg = org
    },
    //设置默认科室
    SET_DEFAULTDEPT: (state, dept) => {
      state.deptinfo = dept
      state.deptid = dept.deptid
    },
    SET_SESSIONINFO: (state, userinfo) => {
      state.sessionInfo = userinfo
    }

  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response
          setToken(data.token)
          local.removeItem('visitedViews')
          commit('SET_TOKEN', data.token)
          commit('SET_SESSIONINFO', data)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    SetDetpInfo({ commit }, dept) {
      commit('SET_DEFAULTDEPT', dept)
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (window.localStorage.getItem('username')) {
          commit('SET_NAME', window.localStorage.getItem('username'))
          resolve()
        } else {
          getInfo(state.token).then(res => {
            window.localStorage.setItem('username', (res.result))
            commit('SET_NAME', res.result)
            resolve()
          }).catch(error => {
            console.log(error)
            // 获取用户名失败不阻塞登录流程
            resolve()
          })
        }
      })
    },
    // todo:默认登录后取第一个机构的id作为默认，可以在【个人中心】界面修改默认
    // 在大型业务系统中，应该让用户登录成功后弹出选择框选择操作的机构
    GetDefaultOrg({ commit, state }) {
      return new Promise((resolve, reject) => {
        getOrgs(state.token).then(response => {
          commit('SET_DEFAULTORG', response.result[0])
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    SetDefaultOrg({ commit, org }) {
      commit('SET_DEFAULTORG', org)

    },
    // 获取用户模块
    GetModules({ commit, state }) {
      return new Promise((resolve, reject) => {
        getModules(state.token).then(response => {
          commit('SET_MODULES', response.result)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户模块
    GetModulesTree({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.modules != null) {
          resolve(state.modules)
          return
        }
        getModulesTree(state.token).then(response => {
          window.localStorage.setItem('modules', JSON.stringify(response))
          // window.localStorage.setItem('SET_MODULES',JSON.stringify(response.result))
          // console.log(response.result);
          commit('SET_MODULES', response.result)
          resolve(response.result)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_MODULES', [])
          commit('SET_SESSIONINFO', {})
          removeToken()
          local.removeItem('visitedViews')         
          local.removeItem('sessionInfo')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit, state }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_MODULES', [])
        commit('SET_SESSIONINFO', {})
        removeToken()
        local.removeItem('visitedViews')
        local.removeItem('sessionInfo')
        resolve()
          //  window.location.href = "/login";  // 根据实际的登录页面路径进行修改
      })

    }


  }
}

export default user
